import * as React from "react";
import DocumentTemplate from "./DocumentTemplate";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";

const PDFExportLink = ({
  translate,
  data,
  title,
  subtitle,
  fileName,
  showTitle
}: {
  translate?: any;
  data: any;
  title?: string;
  subtitle?: string;
  fileName: string;
  showTitle?: boolean;
}) => {
  return (
    <PDFDownloadLink
      document={
        <DocumentTemplate
          translate={translate}
          data={data}
          title={title}
          subtitle={subtitle}
          showTitle={showTitle}
        />
      }
      fileName={fileName}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default PDFExportLink;
